export const apis = {
  initNc: 'GET /open/captcha/nc_message_pc?dwd_appid=2342q341',
  init: 'POST /open/passport/init',
  login: 'POST /open/passport/login',
  getSmsCode: 'POST /open/passport/get_sms_code',
  reg: 'POST /open/passport/reg',
  resetPassword: 'POST /open/passport/reset_pwd'
}